import Model, { attr, belongsTo } from '@ember-data/model';
import type TeamConversationModel from 'uplisting-frontend/models/team-conversation';
import type TeamMessageModel from 'uplisting-frontend/models/team-message';

export default class TeamMentionModel extends Model {
  @attr('string') userId?: string | null;
  @attr('string') name?: string | null;
  @attr('date') readAt?: Date | null;
  @attr('date') createdAt!: Date;

  @belongsTo('team-message', { async: false, inverse: 'teamMentions' })
  teamMessage?: TeamMessageModel | null;

  @belongsTo('team-conversation', { async: false, inverse: null })
  teamConversation?: TeamConversationModel | null;

  get isRead(): boolean {
    return Boolean(this.readAt);
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'team-mention': TeamMentionModel;
  }
}
